import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, ViewEncapsulation, inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import { Client } from 'src/providers/client/client';

import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { WindowService } from 'src/shared/providers/window.service';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { Util } from 'src/shared/util/util';
import { DemoBlockService } from 'src/shared/services/demo-block.service';

const BASE_URL = 'https://x.tidy.com';

@Component({
  selector: 'direct-booking-onboarding',
  templateUrl: './direct-booking-onboarding.component.html',
  styleUrls: ['./direct-booking-onboarding.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class DirectBookingOnboardingComponent implements OnInit {
  private client = inject(Client);
  private rightSidePanelService = inject(RightSidePanelService);
  private navCtrl = inject(CustomNavController);
  private cdr = inject(ChangeDetectorRef);
  private util = inject(Util);
  private storage = inject(TidyStorage);
  private fb = inject(FormBuilder);
  private demoBlock = inject(DemoBlockService);
  windowService = inject(WindowService);

  loaded = false;
  submitted = false;
  isSaving = false;
  fromGettingStarted = false;
  private metadataKey: string;
  private readonly stepId = 'direct';

  config = {
    property_name: 'Oceanview Beach House',
    property_address: '123 Coastal Drive, Malibu, CA 90265',
    site_url: `${BASE_URL}/s/property-1`,
    editor_url: `${BASE_URL}/editor?token=property-1`,
    template: 'V1 Default',
    custom_domain: 'book.oceanviewbeach.com',
  };

  form = this.fb.group({
    customDomain: ['', [Validators.pattern(/^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/)]],
  });

  saveDomain = async () => {
    if (this.demoBlock.block()) { return; }
    this.submitted = true;
    if (!this.form.valid) { return; }

    this.isSaving = true;
    this.cdr.markForCheck();

    await new Promise(resolve => setTimeout(resolve, 1000));

    this.isSaving = false;
    this.cdr.markForCheck();
    this.util.showSuccess('Custom domain settings saved successfully.');
  };

  openEditor = () => {
    if (this.demoBlock.block()) { return; }
    this.util.openUrl(this.config.editor_url);
  };

  openPreview = () => {
    this.util.openUrl(this.config.site_url);
  };

  completeStep = async () => {
    if (this.demoBlock.block()) { return; }
    try {
      await this.client.addMetadata({
        key: this.metadataKey,
        value: 'completed'
      });
      if (this.windowService.isDesktopRes) {
        this.rightSidePanelService.closeRightSidePanel();
      } else {
        this.navCtrl.navigateForward('getting-started');
      }
    } catch (err) {
      this.util.showError('Failed to complete step. Please try again.');
    }
  };

  async ngOnInit() {
    const params = await this.storage.retrieve('dialog-params');
    const addressId = params?.addressId;
    this.fromGettingStarted = !!params?.fromGettingStarted;
    this.metadataKey = `onboarding_step.${addressId}.${this.stepId}`;
    this.rightSidePanelService.setDialogPageTitle('Direct Booking');
    if (this.config.custom_domain) {
      this.form.patchValue({ customDomain: this.config.custom_domain });
    }
    this.loaded = true;
    this.cdr.markForCheck();
  }
}
